var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.manualHiddenProfile
    ? _c(
        "div",
        { staticClass: "narrator-profile", on: { click: _vm.onClick } },
        [
          _c("div", { staticClass: "narrator-profile-discern" }, [
            _c("div", { staticClass: "narrator-profile-discern-inner" }, [
              _c("div", { staticClass: "narrator-profile-portrait" }, [
                _vm.customBranding
                  ? _c(
                      "div",
                      { staticClass: "narrator-profile-portrait-user" },
                      [
                        _vm.portrait
                          ? _c("img", { attrs: { src: _vm.portrait } })
                          : _c("i", { staticClass: "isif isif-man" }),
                      ]
                    )
                  : _c("img", {
                      staticClass: "narrator-profile-portrait-istaging",
                      attrs: { src: _vm.iStagingPortrait },
                    }),
                _vm._v(" "),
                _vm._m(0),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("ModalProfile", { ref: "ModalProfile" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "narrator-profile-more" }, [
      _c("i", { staticClass: "isif isif-dots-3-h" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }